import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslatePipe } from "../../pipe/translation.filter.pipe";
import { ApeModalComponent } from "../ape-modal/ape-modal.component";
import { TalentMatrixUser } from "alloy-performance-engine-cl";
import { TRANSLATION_KEYS } from "../../constants/translations/translation-keys";

/**
 * Interfaccia per i dati di riepilogo di una persona nella modale di conferma
 */
export interface PersonSummary {
  readonly person: TalentMatrixUser;
  readonly hasBeenMoved: boolean;
  readonly currentQuadrant: {
    readonly name: string;
    readonly level: string;
  };
}

/**
 * Componente modale di conferma per la Talent Matrix di Calibrazione
 *
 * CASI D'USO:
 * - Mostrare un riepilogo delle persone posizionate nella matrice
 * - Indicare quali persone sono state spostate in calibration
 * - Permettere all'utente di confermare o annullare l'invio
 * - Fornire feedback chiaro sulle modifiche effettuate
 */
@Component({
  selector: "ape-calibration-talent-matrix-confirmation-modal",
  standalone: true,
  imports: [
    CommonModule,
    TranslatePipe,
    ApeModalComponent
  ],
  templateUrl: "./ape-calibration-talent-matrix-confirmation-modal.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ApeCalibrationTalentMatrixConfirmationModalComponent {
  protected readonly TRANSLATION_KEYS = TRANSLATION_KEYS;

  @Input({ required: true })
  isOpen: boolean = false;

  @Input({ required: true })
  summary: PersonSummary[] = [];

  @Output()
  confirm = new EventEmitter<void>();

  @Output()
  cancel = new EventEmitter<void>();

  @Output()
  close = new EventEmitter<void>();

  /**
   * Gestisce la conferma dell'invio
   */
  protected onConfirm(): void {
    this.confirm.emit();
  }

  /**
   * Gestisce l'annullamento
   */
  protected onCancel(): void {
    this.cancel.emit();
  }

  /**
   * Gestisce la chiusura della modale
   */
  protected onClose(): void {
    this.close.emit();
  }

  /**
   * Formatta il nome completo di una persona
   */
  protected getPersonFullName(person: TalentMatrixUser): string {
    return `${person.surname} ${person.forename}`;
  }

  /**
   * TrackBy function per ottimizzare il rendering della lista
   */
  trackByPersonId(index: number, personSummary: PersonSummary): string {
    return personSummary.person.userId;
  }
}
